module.exports = __webpack_public_path__ + "img/CRT_Spear-003.ee6cfdf5.png";